module.exports = __webpack_public_path__ + "static/media/sale-male-right.6e02bcd1.png";